const feedsInputs = {
  marginBottom: '10px',
};

const container = {
  width: '100%',
}

const col = {
  padding: '2px',
}

export default { feedsInputs, container, col };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Medication/components/MedicationInput/style.js